import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

interface CheckboxContainerProps {
  disabled?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
  htmlFor?: string;
}

interface StyledCheckboxProps {
  error?: boolean;
  checked?: boolean;
  children?: ReactNode;
}

export const CheckboxContainer = styled.label<CheckboxContainerProps>`
  display: flex;
  font-size: 14px;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin-bottom: 0.5rem;

  ${({ disabled }) => disabled && 'opacity: 0.5;'}

  ${({ style }) => ({ ...style })}
`;

interface LabelProps {
  children?: ReactNode;
}

export const Label = styled.span<LabelProps>`
  margin-left: 10px;
`;

interface IconProps {
  src?: string;
  alt?: string;
}

export const Icon = styled.img<IconProps>`
  width: 12px;
  height: 12px;
`;

interface HiddenCheckboxProps {
  type?: string;
  name?: string;
  id?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: any;
  title?: string;
  value?: any;
  disabled?: boolean;
  ref?: any;
}

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })<HiddenCheckboxProps>`
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  visibility: hidden;
`;

export const StyledCheckbox = styled.div<StyledCheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: ${({ theme }) => theme.palette.backgrounds.main};
  transition: all 150ms;
  border: ${({ theme }) => `1px solid ${theme.palette.checkMark}`};

  ${({ error }) => error && 'border: 1px solid red;'}

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`;
